const API_URL = process.env.REACT_APP_API_URL;

let apiUrls =  {
    elements: `${API_URL}/banding-machines`,
    saveSpeedTable: `${API_URL}/banding-machine/save-speed-table`,
    information: `${API_URL}/banding-machine/information`
};

export default apiUrls;
